// extracted by mini-css-extract-plugin
module.exports = {"category":"Category_category__3drLP","name":"Category_name__3oxpz","itemContainer":"Category_itemContainer__2DGwA","titleRow":"Category_titleRow__36foX"};